import { render, staticRenderFns } from "./EmbedModal.vue?vue&type=template&id=b12575e4&scoped=true&"
import script from "./EmbedModal.vue?vue&type=script&lang=ts&"
export * from "./EmbedModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b12575e4",
  null
  
)

export default component.exports